import { ICadastrarCliente } from "../../../Interfaces/Geral/CadastrarCliente/CadastrarClienteInterfaces";
import {
    IListarTipoContas,
    IListarSetor,
    IListarEstados,
    IListarCidades,
    IListarProfissoes,
} from "../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export function CadastrarClienteService(requestBody: ICadastrarCliente) {
    return Service(Axios.post(`/home/clientes/cadastrarcliente`, requestBody));
}

export function ListarTipoContasService() {
    return Service(
        Axios.get<Array<IListarTipoContas>>(`/home/tipocontas/listartipocontas`)
    );
}

export function ListarSetorService() {
    return Service(Axios.get<Array<IListarSetor>>(`/home/setor/listarsetor`));
}

export function ListarEstadosService() {
    return Service(
        Axios.get<Array<IListarEstados>>(`/home/estados/listarestados`)
    );
}
export function ListarCidadeService(idEstado: number) {
    return Service(
        Axios.get<Array<IListarCidades>>(
            `/home/cidades/listarcidades?idEstado=${idEstado}`
        )
    );
}

export function ListarProfissoesService() {
    return Service(
        Axios.get<Array<IListarProfissoes>>(`/home/profissao/listarprofissao`)
    );
}
